import type { Feedback } from '../ratings.ts';

const pct = (avg: number) => `${Math.round((avg / 5) * 100)}%`;

// Retours reçus : moyenne par critère et tags. Avis révélés uniquement (double aveugle).
export function FeedbackSummary({ feedback }: { feedback: Feedback }) {
  if (feedback.count === 0) {
    return <div style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6 }}>Aucun avis révélé pour l'instant. Un avis n'apparaît que lorsque l'autre partie a aussi noté, ou après le délai prévu.</div>;
  }
  const positives = feedback.tags.filter((t) => t.polarity === 'POSITIVE');
  const negatives = feedback.tags.filter((t) => t.polarity === 'NEGATIVE');
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <div style={{ fontSize: 28, fontWeight: 800 }}>{(feedback.score ?? feedback.average)?.toFixed(1) ?? '—'}</div>
        <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>
          {feedback.isNew ? `moyenne sur ${feedback.count} avis : la note ne s'affichera publiquement qu'avec davantage d'avis` : `sur 5 · ${feedback.count} avis`}
        </div>
      </div>
      {feedback.criteria.map((c) => (
        <div key={c.code}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, fontWeight: 600, marginBottom: 4 }}><span>{c.label}</span><span>{c.average.toFixed(1)}</span></div>
          <div style={{ height: 8, background: 'var(--bg)', borderRadius: 99 }}><div style={{ width: pct(c.average), height: '100%', background: 'var(--accent)', borderRadius: 99 }} /></div>
        </div>
      ))}
      {positives.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>{positives.map((t) => <span key={t.code} className="badge badge-available">{t.emoji} {t.label} · {t.count}</span>)}</div>
      )}
      {negatives.length > 0 && (
        <div>
          <div style={{ fontSize: 12, color: 'var(--text-tertiary)', marginBottom: 6 }}>Points à améliorer (retour privé, non affiché publiquement)</div>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>{negatives.map((t) => <span key={t.code} className="badge badge-pending">{t.emoji} {t.label} · {t.count}</span>)}</div>
        </div>
      )}
      {feedback.recent.some((r) => r.comment) && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {feedback.recent.filter((r) => r.comment).map((r) => (
            <blockquote key={r.id} style={{ margin: 0, padding: '8px 12px', borderLeft: '3px solid var(--border)', fontSize: 13, lineHeight: 1.5 }}>« {r.comment} »</blockquote>
          ))}
        </div>
      )}
    </div>
  );
}
